module.exports = __webpack_public_path__ + "static/media/logo4.75b3dc23.png";